/**
 * Created by jimmy on 2019/11/8.
 */
/**
 * Created by jimmy on 2019/8/13.
 */
import 'whatwg-fetch';

const apiPrefix = 'http://www.moidas.com:18080';

export const post = async (settings = {}) => {
	let url = apiPrefix + settings.url;
	let response = await window.fetch(url, {
		method: 'POST',
		headers: {
			"content-type":"application/json; charset=utf-8",
		},
		body: JSON.stringify(settings.data || {})
	});

	response = await response.json();
	return response;
};
